import { Controller } from "@hotwired/stimulus"

// Category groups matching Shift model scopes
const CATEGORY_GROUPS = {
  on_call: ["on_call"],
  task: ["task", "procedure", "clinic", "visit"],
  meeting: ["meeting", "admin"]
}

export default class extends Controller {
  static targets = ["tab", "card"]
  static values = { active: { type: String, default: "all" } }

  filter(event) {
    const category = event.currentTarget.dataset.category
    this.activeValue = category
    this.applyFilter()
    this.updateTabs()
  }

  applyFilter() {
    const group = CATEGORY_GROUPS[this.activeValue] || [this.activeValue]
    this.cardTargets.forEach(card => {
      const cardCategory = card.dataset.shiftCategory
      if (this.activeValue === "all" || group.includes(cardCategory)) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })
  }

  updateTabs() {
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.category === this.activeValue
      tab.classList.toggle("bg-[var(--pu-teal)]", isActive)
      tab.classList.toggle("text-white", isActive)
      tab.classList.toggle("bg-gray-100", !isActive)
      tab.classList.toggle("text-gray-700", !isActive)
    })
  }
}
